const Flickity = require('flickity');
// const Flickity = require('flickity-bg-lazyload');
import 'flickity/css/flickity.css'
if(document.querySelector('.mostreaded'))
{
    const galleryfeed = document.querySelector('.feedcarrusel')
    const flkty = new Flickity( galleryfeed, {
        // options
        cellAlign: 'left',
        // contain: true,
        wrapAround: true,
        pauseAutoPlayOnHover: false,
        pauseAutoPlayOnHover: false,
        cellSelector: '.card',
      });
}
